import { useEffect, useMemo, useRef } from 'react'
import { useAuth } from '../context/AuthContext'
import {
  buildAnalyticsUserContext,
  pushDataLayerEvent,
  setAnalyticsUserContext,
} from './dataLayer'

const getIdentityKey = (context) => [
  context?.user_id || '',
  context?.user?.isLoggedIn ? 'logged-in' : 'anonymous',
  context?.user?.accessLevel || '',
  context?.user?.loginMethod || '',
].join('|')

const AnalyticsIdentityBridge = () => {
  const { user, access, hydrated } = useAuth()
  const previousIdentityKey = useRef('')

  const userContext = useMemo(
    () => buildAnalyticsUserContext(user, { access }),
    [user, access]
  )

  useEffect(() => {
    if (!hydrated) return

    const nextContext = setAnalyticsUserContext(userContext)
    const identityKey = getIdentityKey(nextContext)

    if (previousIdentityKey.current === identityKey) return
    previousIdentityKey.current = identityKey

    pushDataLayerEvent('analytics_identity', nextContext, {
      includeUserContext: false,
    })
  }, [hydrated, userContext])

  return null
}

export default AnalyticsIdentityBridge
